import PropTypes from "prop-types";
import React from "react";

import Loader from "../../shared/components/Loader";
import ResourcesListGroup from "../containers/ResourcesListGroup";
import { ResourceShape, ResourceTypeShape } from "../proptypes";

const ResourcesList = ({
  resources,
  resourceTypes,
  loading,
  openScopesModal
}) => {
  const resourceGroups = loading ? (
    <Loader text="Loading scopes..." />
  ) : (
    resourceTypes.map(resourceType => {
      const resourceItems = resources.filter(
        resource => resource.type.$ref === resourceType.$uri
      );

      if (resourceItems.length) {
        return (
          <ResourcesListGroup
            resourceType={resourceType}
            resources={resourceItems}
            key={resourceType.$uri}
          />
        );
      }
      return undefined;
    })
  );

  return (
    <div className="l-policies__column" style={{ gridArea: "scopes" }}>
      <div className="l-policies__column-header">
        <button
          className="p-button--link p-muted-heading"
          type="button"
          onClick={() =>
            openScopesModal(resourceTypes.length && resourceTypes[0].$uri)
          }
        >
          Scopes
        </button>
      </div>
      <div className="l-policies__column-panel">
        <ul className="p-list">{resourceGroups}</ul>
      </div>
    </div>
  );
};

ResourcesList.propTypes = {
  resources: PropTypes.arrayOf(ResourceShape).isRequired,
  resourceTypes: PropTypes.arrayOf(ResourceTypeShape).isRequired,
  loading: PropTypes.bool.isRequired,
  openScopesModal: PropTypes.func.isRequired
};

export default ResourcesList;
